import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useSettings } from "@/context/SettingsContext";

export default function Confidentialite() {
  const { settings } = useSettings();
  const company = settings?.company_name || "DAS SIMAO AUTO";
  const email = settings?.email || "contact.dassimaoauto@gmail.com";

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="confidentialite-page">
      <SEO title="Politique de confidentialité" description="Politique de confidentialité et de protection des données personnelles — DAS SIMAO AUTO." />
      <Header />
      <article className="pt-32 pb-20 max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.5em] gold uppercase">Légal</div>
        <h1 className="mt-3 font-serif text-white text-5xl leading-tight">Politique de confidentialité</h1>
        <p className="text-gray-500 text-sm mt-2">
          Conforme au Règlement Général sur la Protection des Données (RGPD).
        </p>

        <div className="mt-10 space-y-8 text-gray-300 leading-relaxed text-[15px]">
          <Section title="Données que nous collectons">
            <ul className="list-disc ml-5 space-y-1">
              <li><b>À la réservation :</b> nom, prénom, email, téléphone, adresses de départ et d'arrivée, informations sur le véhicule à convoyer.</li>
              <li><b>Automatiquement :</b> adresse IP, type de navigateur, pages visitées (à des fins strictement techniques et sécuritaires).</li>
              <li><b>Paiement :</b> aucune donnée bancaire n'est stockée sur nos serveurs — Stripe traite l'intégralité de la transaction.</li>
            </ul>
          </Section>

          <Section title="Finalité du traitement">
            <ul className="list-disc ml-5 space-y-1">
              <li>Gérer votre réservation et exécuter la prestation.</li>
              <li>Vous envoyer les emails transactionnels (confirmation, rappel, facture).</li>
              <li>Émettre les documents comptables (devis, facture) requis par la loi.</li>
              <li>Répondre à vos demandes de contact.</li>
            </ul>
          </Section>

          <Section title="Durée de conservation">
            <p>
              Les données de réservation sont conservées 10 ans conformément
              aux obligations comptables et fiscales françaises. Les données
              non contractuelles (contact, waitlist) sont conservées 3 ans
              maximum, sauf demande de suppression anticipée.
            </p>
          </Section>

          <Section title="Cookies">
            <p>
              Le site n'utilise que des cookies techniques strictement
              nécessaires à son fonctionnement (session, panier de
              réservation). Aucun cookie publicitaire ou de tracking
              tiers n'est déposé sans votre consentement explicite.
            </p>
          </Section>

          <Section title="Vos droits">
            <p>
              Conformément au RGPD, vous disposez à tout moment des droits
              suivants sur vos données :
            </p>
            <ul className="list-disc ml-5 space-y-1 mt-2">
              <li>Droit d'accès et de portabilité</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement ("droit à l'oubli")</li>
              <li>Droit d'opposition et de limitation du traitement</li>
              <li>Droit d'introduire une réclamation auprès de la CNIL (cnil.fr)</li>
            </ul>
            <p className="mt-3">
              Pour exercer ces droits, écrivez-nous à{" "}
              <a href={`mailto:${email}`} className="gold underline">{email}</a>.
              Nous répondrons dans un délai maximum de 30 jours.
            </p>
          </Section>

          <Section title="Sous-traitants">
            <ul className="list-disc ml-5 space-y-1">
              <li><b>Stripe (paiement)</b> — société américaine conforme PCI-DSS et RGPD.</li>
              <li><b>Resend / Emergent (email)</b> — envoi des emails transactionnels.</li>
              <li><b>Emergent.sh (hébergement)</b> — infrastructure Kubernetes managée.</li>
            </ul>
          </Section>

          <Section title="Sécurité">
            <p>
              Toutes les communications entre votre navigateur et nos
              serveurs sont chiffrées (HTTPS/TLS). Les mots de passe
              administrateurs sont stockés sous forme de hash bcrypt.
              Les accès à la base de données sont restreints et journalisés.
            </p>
          </Section>

          <Section title="Contact du responsable">
            <p>
              {company} — <a href={`mailto:${email}`} className="gold underline">{email}</a>
            </p>
          </Section>
        </div>
      </article>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-serif text-2xl text-white">{title}</h2>
      <div className="mt-3 space-y-3">{children}</div>
    </section>
  );
}
